import { IResource } from "../i18n";

// tslint:disable-next-line: variable-name
const translation_sr_cyrl: IResource = {
    feedback_button_text: "Пошаљи",
    feedback_cta_0_3: "Стварно нам је жао, молимо Вас реците нам шта да поправимо",
    feedback_cta_4_6: "То је стварно штета, можете нам рећи шта да побољшамо?",
    feedback_cta_7_8: "Шта да урадимо да учинимо Меет још бољим?",
    feedback_cta_9_10: "Фантастично! Шта Вам се највише допало?",
    feedback_mail_subject: "Meet повратна информација",
    feedback_text_legend: "Подједнако смо захвални и на позитивним и на негативним мишљењима",
    feedback_text_title: "Унесите своје мишљење овде (опционо)",
    feedback_title_finished: "Ваш Меет је завршен",
    feedback_title_ongoing: "Молимо Вас помозите нам да побољшамо Меет",
    feedback_title_question: "Колико је вероватно да ће те препоручити Meet пријатељу или колеги?",
    feedback_value_best: "Врло вероватно",
    feedback_value_worst: "Скоро невероватно",

    onboarding_button_jointext: "СТАРТ",
    onboarding_description_four: "дугме.",
    // tslint:disable-next-line: max-line-length
    onboarding_description_one: "С обзиром да користите Meet по први пут, можете подесити како Вас ваши саговорници виде.",
    onboarding_description_three: "СТАРТ",
    onboarding_description_two: "Кад сте спремни, само кликните",
    onboarding_label_color: "Боја",
    onboarding_label_consentAgree: "Слажем се са Meet",
    onboarding_label_consentAnd: "и",
    onboarding_label_consentPrivacy: "Политиком приватности",
    onboarding_label_consentTermsOfUse: "Условима коришћења",
    onboarding_label_darkTheme: "Тамна тема",
    onboarding_label_firstName: "Ваше име (необавезно)",
    onboarding_label_green: "Зелена",
    onboarding_label_indigo: "Плава",
    onboarding_label_lastName: "Ваше презиме (необавезно)",
    onboarding_label_lightTheme: "Светла тема",
    onboarding_label_orange: "Наранџаста",
    onboarding_label_pink: "Лила",
    onboarding_label_purple: "Љубичаста",
    onboarding_label_teal: "Тиркизна",
    onboarding_label_theme: "Тема",
    onboarding_label_yellow: "Жута",
    onboarding_title: "Добродошли!",

    invite_legend_text: "Пошаљите линк особи с којом желите да се састанете",
    invite_link_copy: "Копирајте линк",
    invite_link_defaultCopied: "Линк је копиран!",
    invite_link_email: "Пошаљите линк",
    invite_link_label: "Ваш позивни линк",
    invite_link_sms: "СМС позивница",
    invite_mail_body: "Поздрав, молим придружите ми се на Meet-у!",
    invite_mail_signature: "С поштовањем",
    invite_mail_subject: "Ваш линк за Meet",
    invite_title_text: "ПОЗОВИТЕ НЕКОГ У МЕЕТ",

    citypicker_label: "Град",
    citypicker_nomatch: "Нема сличних градова",

    userprofile_city_label: "Град",
    userprofile_color_label: "Боја",
    userprofile_email_label: "Е-маил адреса",
    userprofile_label_green: "Зелена",
    userprofile_label_indigo: "Плава",
    userprofile_label_orange: "Наранџаста",
    userprofile_label_pink: "Лила",
    userprofile_label_purple: "Љубичаста",
    userprofile_label_teal: "Тиркизна",
    userprofile_label_yellow: "Жута",
    userprofile_locale_label: "Језик",
    userprofile_name_label: "Име",
    userprofile_surname_label: "Презиме",
    userprofile_theme_label: "Тема",
    userprofile_themedark_label: "Тамна тема",
    userprofile_themelight_label: "Светла тема",

    options_tab_profile: "Профил",

    consentdialog_button_cancel: "Откажи",
    consentdialog_button_ok: "OK",

    layout_meet_end: "Крај састанка",
    layout_meet_leave: "Напустите састанак",

    layout_sidebar_labelClose: "Затвори бoчни мени",
    layout_sidebar_labelOpen: "Отвори бочни мени",
    layout_sidebar_labelTitle: "Отвaрање бочног менија",
    layout_title_text: "Meet | Састанци без муке",

    layout_toolbar_enter: "Прелазак у пуни екран",
    layout_toolbar_invite: "Додајте саговорника",
    layout_toolbar_invite_tooltip: "Позовите новог саговорника да се придружи овом састанку",
    layout_toolbar_leave: "Излазак из пуног екрана",

    layout_dialog_descriptionEnd: "Ово ће окончати састанак за све учеснике",
    layout_dialog_titleEnd: "Да ли сте сигурни да желите да окончате састанак?",
    layout_dialog_titleLeave: "Да ли желите да напустите овај састанак?",

    layout_dialog_descriptionLeave: "Ово НЕЋЕ окончати састанак за остале учеснике",
    layout_sidebar_explorer: "Помоћ",
    layout_sidebar_feedback: "Ваше мишљење",
    layout_sidebar_settings: "Подешавања",

    layout_finish_endmeet: "Крај састанка",
    layout_finish_leavemeet: "Напустите састанак",

    layout_cta_register: "Дужи састанак?",
    layout_cta_register_tooltip: "Региструјте се за састанке дуже од 20 мин",

    layout_dialog_descriptionAbandon: "Изгледа да сте још само ви остали на позиву",
    layout_dialog_titleAbandon: "Да ли желите да окончате овај састанак?",

    language_en_title: "English",
    language_es_title: "Español",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_de_title: "Deutsche",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    meeting_finished_title: "ЗАВРШЕН САСТАНАК",
    meeting_finished_tooltip: "Oграничени приступ",

    layout_reactivate_button: "Реактивација Meet-а",
    layout_reactivate_tooltip: "Кликните овде да би сте отворили овај завшени Меет за поновну употребу",
    layout_dialog_titleReactivate: "Да ли сте сигурни да желите да поново реактивирате овај састанак?",
    layout_dialog_descriptionReactivate: "Ово ће поново омогућити коришћење овог Меет-а за разговор и колаборацију",

    toast_reconnecting_title: "Проблем са сигнализацијом позива",
    toast_reconnecting_message: "Веза (стање: {state}) је изгубљена због грешке {error}. Поновно повезивање ...",
    toast_reconnected_title: "Сигнализација позива",
    toast_reconnected_message: "Веза је успостављена. Стање: {state}",
    toast_disconnected_title: "Грешка у сигнализацији позива",
    toast_disconnected_message: "Веза (стање: {state}) је затворена због грешке {error}." +
                                "Учитајте поново ову страницу да бисте покушали да обновите везу сигнализације позива.",

    config_title_text: "Креирај нови Meet",
    config_title_ctaOne: "Молимо Вас да дефинишете особине састанка који желите да имате.",
    config_title_ctaTwo: "Свака од особина је необавезна и можете прескочити њен унос.",
    config_title_label: "Назив",
    config_description_label: "Опис",
    config_duration_label: "Трајање",
    config_tool_label: "Meet алати",
    config_tool_call: "Видео позив",
    config_tool_editor: "Едитор програмског кода",
    config_tool_whiteboard: "Табла за цртање",
    config_passcode_label: "Шифра за приступ (ако је има)",

    search_placeholder_text: "Унесите критеријум претраге...",
    createMeeting_button_create: "Направи састанак",

    projectboard_scheduleinfo_none: "Састанак нема одређен датум и може почети било кад",
    projectboard_scheduleinfo_anytime: "било кад",

    projectboard_join_anyone: "Било ко са линком може се прикључити позиву",
    projectboard_role_guest: "Гост",
    projectboard_role_interviewee: "Кандидат",
    projectboard_role_interviewer: "Послодавац",
    projectboard_role_organizer: "Организатор",

    projectboard_status_draft: "У изради",
    projectboard_status_scheduling: "У заказивању",
    projectboard_status_schedulingFailed: "Заказивање неуспело",
    projectboard_status_pending: "Спреман-на чекању",
    projectboard_status_ready: "Спреман",
    projectboard_status_starting: "Почиње",
    projectboard_status_inprogress: "У току",
    projectboard_status_onhold: "На чекању",
    projectboard_status_completed: "Завршен",
    projectboard_status_canceled: "Отказано",
    projectboard_status_archived: "Архивирано",
    projectboard_status_feedbackWait: "Чекање на повратну информацију",
    projectboard_status_feedbackDone: "Повратну информација прикупљена",
    projectboard_status_feedbackFail: "Повратна информација није прикупљена",

    projectboard_status_stopped: "Прекинуто",

    minibar_dashboard_title: "Табла",

    layout_sidebar_rateus: "Оцените нас",

    invite_passcode_label: "Шифра",

    invite_text_copy: "Копирај позив",
    
    invite_text_body: "Молим вас придружите се састанку на {url}",
    
    invite_passcode_body: "Придружите се састанку на {url} и користите кôд за пролаз {passcode}",

    invite_text_copied: "Текст позивнице за састанак са подацима за приступ је копиран у ostavu (clipboard)",
        
    invite_pascode_add: "Додај шифру за пролаз УРЛ адреси",
    
    participant_join_message : "{participant} се придружио састанку.",
    participant_left_message : "{participant} је напустио састанак.",

    minibar_dashboard_tooltip: "Управљање вашим Меет-овима",

    layout_sidebar_snapshot: "Снимци",

    snapshots_none_text : "Направите један или више снимака кода и цртежа и прегледајте их након састанка.",
    snapshot_toast_text: "Снимак sачуван",
    snapshots_cta_text : "Направите снимак (F9)",
    snapshot_sentiment_positive : "Позитиван снимак",
    snapshot_sentiment_negative : "Негативан снимак",
    snapshot_sentiment_note : "Напомена",
    
    snapshot_personal_value : "Лични снимак",
    snapshot_personal_title : "Видљиво само теби",
    snapshot_team_value : "Снимак тима",
    snapshot_team_title : "Видљиво само вашем тиму.",
    snapshot_public_title : "Видљиво свим учесницима",
    snapshot_public_value : "Јавни снимак",

    snapshots_live_text : "Врати се у интервјуу уживо",
    
    snapshot_action_delete : "Избриши",
    snapshot_action_load : "Учитај снимак",

    snapshot_delete_dialog_title : "Избриши снимак?",
    snapshot_delete_dialog_description : "Молимо вас да потврдите да желите да избришете овај снимак",
    snapshots_final_back: "Назад на коначно стање Меет-а",
};

export default translation_sr_cyrl;
